import { THEME } from "@/themes/types";
import { SiteInfo } from "../types";

const { indexedPaths } = require("../seo.ts");

export const localhostQRCreator: SiteInfo = {
  domainName: "localhost",
  siteName: "QR Creator Local",
  siteTheme: process.env.NEXT_PUBLIC_THEME as THEME,
  siteEmail: "info@qrcreatorlocal.com",
  siteWhiteLogo: "/svg/logo-white.svg",
  siteBlackLogo32: "/svg/logo32.svg",
  siteBlackLogo28: "/svg/logo28.svg",
  siteBlackLogoFooter: "/svg/logoFooter.svg",
  favicon: "/images/favicon-default.png",
  indexedPaths: indexedPaths["qrcreator.com"],
};
